/**
 * Agent-specific display language.
 *
 * The UI was originally written for the Competitive Analysis agent, so several
 * labels hardcoded "competitive/competitors". This module centralizes those
 * strings so each agent shows appropriate language. Unknown/missing agent ids
 * fall back to the competitive defaults (legacy behavior).
 */

export interface AgentLanguage {
  /** e.g. "competitive analysis" — used in intro and chat welcome sentences */
  analysisPhrase: string;
  /** Copilot stage bar, Stage 2 title */
  stage2Title: string;
  /** Brief Builder right-panel card heading for the second block */
  competitorHeading: string;
  /** Workspace Scope document heading for the second block */
  scopeHeading: string;
}

const AGENT_LANGUAGE: Record<string, AgentLanguage> = {
  competitive: {
    analysisPhrase: 'competitive analysis',
    stage2Title: 'Competitors Identified',
    competitorHeading: 'Competitor Landscape',
    scopeHeading: 'Competitors',
  },
  market_research: {
    analysisPhrase: 'market research',
    stage2Title: 'Trend Categories Identified',
    competitorHeading: 'Trend Categories',
    scopeHeading: 'TREND CATEGORIES',
  },
  customer_research: {
    analysisPhrase: 'customer research',
    stage2Title: 'Customer Segments Identified',
    competitorHeading: 'Customer Segments',
    scopeHeading: 'Customer Segments',
  },
};

const normalizeAgentId = (agentId?: string | null): string =>
  (agentId || '').trim().toLowerCase().replace(/-/g, '_');

export const getAgentLanguage = (agentId?: string | null): AgentLanguage =>
  AGENT_LANGUAGE[normalizeAgentId(agentId)] || AGENT_LANGUAGE.competitive;
